import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

const CHUNK_RELOAD_KEY = 'kcn_stale_chunk_reload';

function isStaleChunkError(error: Error | undefined): boolean {
    const message = error?.message || '';
    return /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk [\w-]+ failed|error loading dynamically imported module/i.test(
        message,
    );
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);

        if (isStaleChunkError(error) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
            sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
            window.location.reload();
        }
    }

    componentDidMount() {
        window.setTimeout(() => {
            sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        }, 4000);
    }

    render() {
        if (this.state.hasError) {
            const staleChunk = isStaleChunkError(this.state.error);
            return (
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                        <h1 className="text-4xl font-bold text-red-600 mb-4">Đã xảy ra lỗi</h1>
                        <p className="text-lg text-gray-700 mb-6">
                            {staleChunk
                                ? 'Phiên bản trang đã cũ sau khi cập nhật. Vui lòng tải lại trang.'
                                : 'Rất tiếc, đã xảy ra lỗi không mong muốn. Vui lòng thử lại sau.'}
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-6 py-3 bg-[#C4A35A] text-white rounded-lg hover:bg-[#9A7B2E] transition-colors"
                        >
                            Tải lại trang
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
